
/**
 * 상세 에러 정보
 * @nullable
 */
export type PostApiV1RefundsCancelSubscription500ErrorDetails = { [key: string]: unknown } | null;
